import React from "react";
import { Check } from "react-feather";
import i18next from "i18next";
import PropTypes from "prop-types";

const POINTS = [
    i18next.t("franchise.requirements.points.first"),
    i18next.t("franchise.requirements.points.second"),
    i18next.t("franchise.requirements.points.third"),
    i18next.t("franchise.requirements.points.fourth"),
    i18next.t("franchise.requirements.points.fifth"),
    i18next.t("franchise.requirements.points.sixth"),
    i18next.t("franchise.requirements.points.seventh"),
];

export const RequirementsSection = () => {
    return (
        <div className="franchise-requirements-section">
            <div className="franchise-requirements-section__banner">
                <div className="franchise-requirements-section__banner__bowl"></div>
            </div>
            <div className="container">
                <div className="franchise-requirements-section__points">
                    <p className="franchise-requirements-section__points__heading">
                        {i18next.t("franchise.requirements.heading")}
                    </p>
                    {POINTS.map((text, idx) => (
                        <Point key={`requirements-point-${idx}`} text={text} />
                    ))}
                </div>
            </div>
        </div>
    );
};

const Point = ({ text }) => {
    return (
        <div className="franchise-requirements-section__point">
            <div className="icon">
                <Check color="#00E940"></Check>
            </div>
            <p className="text">{text}</p>
        </div>
    );
};

Point.propTypes = {
    text: PropTypes.string,
};

export default RequirementsSection;
